import { createSlice } from "@reduxjs/toolkit";
import { defaultDummyClient } from "../../clients/DummyClient";
import { createAsyncThunk } from "@reduxjs/toolkit";

export enum AsyncActionStatus {
    UNSTARTED = "UNSTARTED",
    STARTED = "STARTED",
    SUCCEEDED = "SUCCEEDED",
    FAILED = "FAILED",
}
export interface DummyState {
    status: AsyncActionStatus;
    error?: string;
    greeting?: string;
}

const initialState: DummyState = {
    status: AsyncActionStatus.UNSTARTED,
};

const loadGreeting = createAsyncThunk(
    "dummy/getGreeting",
    async () => (await defaultDummyClient.getGreeting()) as string,
);

export const dummySlice = createSlice({
    name: "dummy",
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(loadGreeting.pending, state => {
                state.status = AsyncActionStatus.STARTED;
            })
            .addCase(loadGreeting.fulfilled, (state, { payload }) => {
                state.status = AsyncActionStatus.SUCCEEDED;
                state.greeting = payload;
            })
            .addCase(loadGreeting.rejected, (state, { error }) => {
                state.status = AsyncActionStatus.FAILED;
                state.error = error.message;
            });
    },
});

export const DummyActions = {
    ...dummySlice.actions,
    loadGreeting,
};
